export function isNodeList (el: any) {
  // Only NodeList has the "item()" function
  return typeof el.item !== "undefined";
}